module.exports = __webpack_public_path__ + "img/ballot.61a82faa.svg";